<template>
  <div class="body">
    <!-- <div class="form bg-white p20 mb30">
      <el-form ref="form" :model="form" label-width="80px">
        <el-row>
          <el-col :span="6" class="pr20">
            <el-form-item label="培训名称" prop="trainingName">
              <el-input v-model="form.trainingName"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6" class="pr20">
            <el-form-item label="创建人" prop="createdBy">
              <el-input v-model="form.createdBy"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6" class="pr20">
            <el-form-item label="培训内容" prop="trainingContent">
              <el-input v-model="form.trainingContent"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-row>
            <el-col :span="6" class="pr20">
              <el-form-item label="下发人" prop="issueId">
                <el-select v-model="form.issueId" placeholder="请选择">
                  <el-option
                    v-for="item in principalList"
                    :key="item.id"
                    :label="item.userName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="pr20">
              <el-form-item label="下发时间" prop="issuedTime">
                <el-date-picker
                  value-format="timestamp"
                  v-model="form.issuedTime"
                  type="date"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-col :span="12" class="pr20">
            <el-form-item label="培训时间" prop="date">
              <el-date-picker
                v-model="form.date"
                type="daterange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="getTrainList">搜索</el-button>
          <el-button type="primary" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </div> -->

    <div class="bg-white p20 pb50">
      <el-table class="mb20" :data="trainList" style="width: 100%">
        <!-- <el-table-column prop="trainingName" label="培训名称"></el-table-column> -->
        <el-table-column prop="userName" label="培训人员"></el-table-column>
        <!-- <el-table-column prop="createdBy" label="创建人"></el-table-column>
        <el-table-column
          prop="trainingStartTime"
          label="培训开始时间"
        ></el-table-column>
        <el-table-column prop="trainingName" label="培训内容"></el-table-column> -->
        <!-- <el-table-column prop="issueName" label="下发人"></el-table-column>
        <el-table-column prop="issuedTime" label="下发时间"></el-table-column> -->
        <!-- <el-table-column
          prop="trainingEndTime"
          label="完成时间"
        ></el-table-column> -->

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="showStudyProgress(scope.row.id)"
              >查看详情</el-button
            >
            <!-- <el-button
              size="mini"
              type="primary"
              @click="$router.push(`/student/train?id=${scope.row.id}`)"
              >开始学习</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>

      <el-button type="primary" @click="$router.go(-1)">返回</el-button>

      <el-pagination
        style="float:right;"
        background
        layout="total ,prev, pager, next"
        :total="total"
        :page-size="pageSize"
        @current-change="pageChange"
      ></el-pagination>
    </div>

    <studyProgress ref="studyProgress" :id="detailId"></studyProgress>
    <!-- 培训详情 -->
    <!-- <el-dialog title="培训详情" :visible.sync="isShowTrainDetail" width="70%">
      <div class="trainDetail">
        <el-row>
          <el-col :span="12" style="border-bottom:1px solid #99999950;">
            <span class="span-left">培训名称：</span>
            <span>培训计划</span>
          </el-col>
          <el-col :span="12" style="border-bottom:1px solid #99999950;">
            <span class="span-left">培训名称：</span>
            <span>培训计划</span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12" style="border-bottom:1px solid #99999950;">
            <span class="span-left">培训名称：</span>
            <span>培训计划</span>
          </el-col>
          <el-col :span="12" style="border-bottom:1px solid #99999950;">
            <span class="span-left">培训名称：</span>
            <span>培训计划</span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12" style="border-bottom:1px solid #99999950;">
            <span class="span-left">培训名称：</span>
            <span>培训计划</span>
          </el-col>
          <el-col :span="12" style="border-bottom:1px solid #99999950;">
            <span class="span-left">培训名称：</span>
            <span>培训计划</span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12" style="border-bottom:1px solid #99999950;">
            <span class="span-left">培训名称：</span>
            <span>培训计划</span>
          </el-col>
          <el-col :span="12" style="border-bottom:1px solid #99999950;">
            <span class="span-left">培训名称：</span>
            <span>培训计划</span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12" style="border-bottom:1px solid #99999950;">
            <span class="span-left">培训名称：</span>
            <span>培训计划</span>
          </el-col>
          <el-col :span="12" style="border-bottom:1px solid #99999950;">
            <span class="span-left">培训名称：</span>
            <span>培训计划</span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" style="border-bottom:1px solid #99999950;">
            <span class="span-left">培训名称：</span>
            <span>培训计划</span>
          </el-col>
        </el-row>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
/**
 * page:当前页
pageSize:每页大小
trainingName:培训名称
trainingStartTime:培训开始时间
trainingEndTime:培训结束时间
issuedTime:下发时间
createdBy:创建人
issueId:下发人
trainingContent:培训内容
 */
import api from "../../api/new/training.js";
import student from "../../api/new/student.js";
import studyProgress from "@/components/studyProgress";
export default {
  components: { studyProgress },
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0, // 总条数
      form: {
        trainingName: undefined,
        trainingStartTime: undefined,
        trainingEndTime: undefined,
        issuedTime: undefined,
        createdBy: undefined,
        issueId: undefined,
        trainingContent: undefined,
        date: []
      },
      trainList: [],
      principalList: [],
    };
  },
  mounted() {
    this.principalList = JSON.parse(localStorage.getItem("principalList"));
    this.getTrainList();
  },
  methods: {
    showStudyProgress(id) {
      this.$refs.studyProgress.open(id);
    },
    getTrainList() {
      let p = {
        page: this.page,
        pageSize: this.pageSize,
        tasksJoinUserId: this.$route.query.id,
        programTasksId: this.$route.query.programTasksId,
        ...this.form
      };
      if (p.date.length > 0) {
        p.trainingStartTime = p.date[0];
        p.trainingEndTime = p.date[1];
      }
      delete p.date;
      if (p.date && p.date.length > 0) {
        p.startTime = p.date[0];
        p.endTime = p.date[1];
      }
      student.getTrainList(p).then(res => {
        this.trainList = res.data.records;
        this.total = res.data.total;
      });
    },
    resetForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
    },
    pageChange(e) {
      this.page = e;
      this.getTrainList();
    }
  }
};
</script>

<style scoped>
.form {
  position: relative;
}
.searchBut {
  position: absolute;
  right: 20px;
  top: 20px;
}

.trainDetail {
  padding: 20px;
}
.trainDetail span {
  font-size: 20px;
  line-height: 70px;
  display: inline-block;
}
.trainDetail .span-left {
  padding-left: 30px;
  width: 200px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/trainingManagement/trainingDetail.vue